// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  StatsTable,AnimatedView,GameTypeTab
}                         from '../../components';
import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../components';
import {Link} from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';

class BatchHealth extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      main_tabs: [
        {name: 'Fixtures', tablink: '1', isActive: false},
        {name: 'Sessions', tablink: '2', isActive: false},
        {name: 'Packages', tablink: '3', isActive: false},
        {name: 'Buddy Allocation', tablink: '4', isActive: true},
      ]
    };
  }

  static propTypes = {
    actions: PropTypes.shape({
    })
  };

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('BatchHealth');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded
      }
    } = this.props;
    //$('.tab-panel-nik').find(".panel-heading").find("a").first().trigger("click");
    $('.tab-panel-nik').find(".panel-heading").find("a").each(function( index ) {
      if(index==0){
        $(this).trigger("click");
      }
    });
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('BatchHealth');
  }


  componentDidUpdate(prevProps, prevState) {
  }

  handleRequestClose = () => {
  this.setState({
    open: false,
    });
  };

  handleClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };


  render() {
    const {
      statsTable
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded
      }
    } = this.props;

    return(
      <div>
        <div className="row" style={{padding: '1%'}}>
          <RaisedButton
            onClick={this.handleClick}
            label="Add"
            style={{float:'right'}}
            secondary={true}
          />
          <Popover
            open={this.state.open}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'left', vertical: 'top'}}
            onRequestClose={this.handleRequestClose}
          >
            <Menu>
              <Link to={`./crud/createFixture`}><MenuItem primaryText="Batch" /></Link>
              <Link to={`./crud/hostGame`}><MenuItem primaryText="Host a Game" /></Link>
            </Menu>
          </Popover>
        </div>
        <div className="row">
          <TabPanel>
            <TabPanelHeader tabItems={this.state.main_tabs}/>

              <TabPanelBody>
                <TabPanelBodyContent id="1">
                  <div>
                      <StatsTable bigTable={true} displayName="Utilization" name="venue_utilization" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                  </div>
                  <div>
                    <GameTypeTab bigTable={true} displayName="Batch Health" name="batch_health" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                  </div>
                </TabPanelBodyContent>

                <TabPanelBodyContent id="2">
                  <div>
                    <GameTypeTab bigTable={true} name="sessions_lists" displayName="Sessions" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                  </div>
                </TabPanelBodyContent>

                <TabPanelBodyContent id="3">
                  <div>
                    <StatsTable bigTable={true} name="package_list" displayName="Package List" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                  </div>
                </TabPanelBodyContent>

                <TabPanelBodyContent id="4">
                  <div>
                    <StatsTable bigTable={true} name="fixture_buddy_allocation" displayName="Fixture Buddy Allocation" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                  </div>
                  <div>
                    <StatsTable bigTable={true} name="sessions_buddy_allocation" displayName="Session Buddy Allocation" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                  </div>
                </TabPanelBodyContent>

            </TabPanelBody>
          </TabPanel>
        </div>
      </div>
    );
  }
}

export default BatchHealth;



// WEBPACK FOOTER //
// ./src/app/views/batchhealth/BatchHealth.js